export function InteractiveProductApp(product) {
  return {
    lowercasedCountryIsoCode: window.Shopify.country?.toLowerCase(),
    get showOverrideImage() {
      const overrideMetafield =
        product.selected_or_first_available_variant.metafields.custom.data_override;
      if (!overrideMetafield) return false;

      const localizedOverrideData = overrideMetafield[this.lowercasedCountryIsoCode];
      if (!localizedOverrideData || Object.keys(localizedOverrideData).length === 0) return false;

      return localizedOverrideData?.show_interactive_product_override_image || false;
    },
    $delimiters: ['${', '}$'],
  };
}
